import { LDate } from '@app/components/date/LDate';
import { LTime } from '@app/components/date/LTime';
import { StationLink } from '@app/components/stations/StationLink';
import { FragmentLink } from '@app/modules/fragments/components/FragmentLink';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { socialExport } from '@mi-front/api-clients';
import { DateTimeStr } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { Box, Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { QueryView } from '@ui/utils/async-view/QueryView';

type Props = {
  platform: SocialPlatform;
};

export const PlatformUploaded = ({ platform }: Props) => {
  const { $t } = useIntl();
  const query = socialExport.useListByPlatformUploadStatus(platform.id);

  return (
    <Box mt={0}>
      <QueryView query={query}>
        {(data: socialExport.ListByPlatformUploadStatus200) => (
          <MrtTable
            data={data.results}
            columns={[
              {
                header: $t({
                  id: 'socialExport.uploaded.columnStation',
                  defaultMessage: 'Estación',
                }),
                accessorKey: 'stationId',
                Cell: ({ row }) => (
                  <StationLink
                    id={row.original.stationId}
                    link={`/fragments/s/${row.original.stationId}`}
                  />
                ),
              },
              {
                header: $t({
                  id: 'socialExport.uploaded.columnFragment',
                  defaultMessage: 'Fragmento',
                }),
                accessorKey: 'fragmentId',
                Cell: ({ row }) => {
                  const source = row.original.source as socialExport.FragmentSourceDto;
                  return (
                    <FragmentLink
                      stationId={row.original.stationId}
                      id={source.data.fragmentId}
                    />
                  );
                },
              },
              {
                header: $t({
                  id: 'socialExport.uploaded.columnStatus',
                  defaultMessage: 'Estado',
                }),
                accessorKey: 'status',
                Cell: ({ row }) => (
                  <Chip
                    color={
                      row.original.status === socialExport.UploadDtoStatusEnum.COMPLETED
                        ? 'success'
                        : row.original.status === socialExport.UploadDtoStatusEnum.IN_PROGRESS
                          ? 'info'
                          : row.original.status === socialExport.UploadDtoStatusEnum.SCHEDULED
                            ? 'warning'
                            : 'error'
                    }
                    label={row.original.status}
                  />
                ),
              },
              {
                header: $t({
                  id: 'socialExport.uploaded.columnPublished',
                  defaultMessage: 'Publicado',
                }),
                accessorKey: 'createdAt',
                Cell: ({ row }) => (
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <LDate
                      value={row.original.createdAt as DateTimeStr}
                      day="2-digit"
                      month="2-digit"
                      year="2-digit"
                    />
                    <LTime value={row.original.createdAt as DateTimeStr} second={'numeric'} />
                  </div>
                ),
              },
            ]}
          />
        )}
      </QueryView>
    </Box>
  );
};
